var _g, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_285_2835)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.7002,
    y: 2.50391,
    width: 48.3333,
    height: 45,
    rx: 20.5282,
    fill: "#E9EAEC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5619 32.1903H19.9932C19.9471 32.1903 19.9027 32.1712 19.8705 32.139C19.8375 32.1059 19.8192 32.0624 19.8192 32.0163C19.8192 32.0154 19.8192 30.7548 19.8192 30.7548C19.8192 30.0318 20.3351 29.3949 21.1303 28.8538C22.5502 27.8846 24.848 27.2738 27.432 27.2738C27.8583 27.2738 28.2767 27.2912 28.6857 27.3234C29.0441 27.3521 29.3591 27.0841 29.3878 26.7248C29.4156 26.3655 29.1476 26.0514 28.7883 26.0227C28.3464 25.987 27.8939 25.9688 27.432 25.9688C24.5417 25.9688 21.983 26.6917 20.3943 27.7749C19.1823 28.6015 18.5142 29.6516 18.5142 30.7539V32.0163C18.5142 32.4078 18.6699 32.7846 18.9474 33.0621C19.225 33.3388 19.6008 33.4954 19.9932 33.4945C21.7472 33.4954 26.5619 33.4954 26.5619 33.4954C26.9221 33.4954 27.2144 33.2022 27.2144 32.8428C27.2144 32.4827 26.9221 32.1903 26.5619 32.1903Z",
    fill: "#0D152B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4319 15.6484C24.7905 15.6484 22.6467 17.7922 22.6467 20.4336C22.6467 23.075 24.7905 25.2188 27.4319 25.2188C30.0733 25.2188 32.217 23.075 32.217 20.4336C32.217 17.7922 30.0733 15.6484 27.4319 15.6484ZM27.4319 16.9535C29.3529 16.9535 30.912 18.5126 30.912 20.4336C30.912 22.3546 29.3529 23.9137 27.4319 23.9137C25.5109 23.9137 23.9518 22.3546 23.9518 20.4336C23.9518 18.5126 25.5109 16.9535 27.4319 16.9535Z",
    fill: "#0D152B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2191 32.142C34.2736 32.3003 35.3881 31.9732 36.1999 31.1615C37.5588 29.8025 37.5588 27.5961 36.1999 26.238C34.8417 24.879 32.6353 24.879 31.2764 26.238C30.4646 27.0497 30.1375 28.1642 30.2958 29.2196L28.2756 31.2389C28.153 31.3616 28.0842 31.5278 28.0842 31.7009V33.7011C28.0842 34.0613 28.3766 34.3536 28.7367 34.3536H30.7369C30.9101 34.3536 31.0763 34.2849 31.1989 34.1622L33.2191 32.142ZM33.1739 30.8022C32.9494 30.7421 32.7093 30.8065 32.5449 30.9709L30.4672 33.0486H29.3893V31.9706L31.4669 29.893C31.6313 29.7285 31.6957 29.4884 31.6357 29.2639C31.4425 28.5375 31.6296 27.7301 32.1995 27.1602C33.0486 26.3111 34.4276 26.3111 35.2776 27.1602C36.1268 28.0102 36.1268 29.3892 35.2776 30.2384C34.7078 30.8082 33.9004 30.9953 33.1739 30.8022Z",
    fill: "#0D152B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0709 29.3676C32.7029 28.9996 32.7029 28.4019 33.0709 28.0338C33.439 27.6658 34.0367 27.6658 34.4047 28.0338C34.7727 28.4019 34.7727 28.9996 34.4047 29.3676C34.0367 29.7356 33.439 29.7356 33.0709 29.3676Z",
    fill: "#0D152B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_285_2835",
    x: 0.41569,
    y: 0.0405274,
    width: 54.9023,
    height: 51.569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.821126
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.64225
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_285_2835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_285_2835",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionIcon);
export default __webpack_public_path__ + "static/media/PermissionIcon.ca742258d05bcd4aebe9d2266dd5c1f1.svg";
export { ForwardRef as ReactComponent };